export default __webpack_public_path__ + "static/media/TCRB.4e18a036.png";